import React from "react";
import ReactDOM from "react-dom/client";
import cn from "classnames";
import {createStore, withStore} from "game_play/utils/store";
import {createLocationObserver} from "championship/src/components/LocationHashObserver";
import DatePicker, {renderInputDateStepper} from "championship/src/components/DatePicker";
import EmptyState from "championship/src/components/EmptyState/emptyState";
import Tournaments, {toRequestDate} from "../model/tournaments";

import '../static/tournament/style/tournaments.css'

const LocationObserver = createLocationObserver({
  hashKey: 'tournament',
  defaultValue: 'all'
})

const formattedDate = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});

class TableTournaments extends React.Component {
  state = {
    activeTab: LocationObserver.getValue(),
    completed: LocationObserver.getValue() === 'past' ? true : null,
    date: null,
  }

  unsubscribeSocket = null

  onLocationValueChange = (value) => {
    this.setState({
      activeTab: value, completed: value === 'past' ? true : null, date: null
    })
  }

  handlerRowClick = (tournament, handler) => (e) => {
    if (e.target.closest('[data-inside-link]')) return;
    if (e.target.closest('[data-inside-button]')) {
      e.preventDefault();
      return;
    }

    if (handler && handler(tournament)) {
      e.preventDefault()
    }
  }

  handlerShiftDay = (shift) => () => {
    if (!this.state.date) this.setState({date: new Date()})
    const newDate = new Date(this.state.date);
    newDate.setDate(this.state.date.getDate() + shift);
    this.setState({date: newDate})
  }

  fetchTournaments(force) {
    const {Tournaments} = this.props
    const requestDate = toRequestDate(this.state.date)
    Tournaments.fetch({date: requestDate, completed: this.state.completed}, force)
    if (this.unsubscribeSocket) this.unsubscribeSocket()
    // this.unsubscribeSocket = Tournaments.subscribe({date: requestDate})
  }

  filterTournament(tournaments, filter) {
    return tournaments.filter(tournament => {
      if (filter === 'past') {
        return tournament.completed
      }
      return true
    })
  }

  componentDidMount() {
    this.fetchTournaments(true)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.date !== prevState.date || this.state.completed !== prevState.completed) {
      this.fetchTournaments(true)
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeSocket) {
      this.unsubscribeSocket()
    }
  }

  render() {
    const {Tournaments} = this.props
    const tournaments = Tournaments.get('tournaments')
    const {date} = this.state
    const activeTab = this.state.activeTab

    const tournamentsFiltered = this.filterTournament(tournaments, activeTab)

    return (
      <div>
        <LocationObserver.Component onValueChange={this.onLocationValueChange}/>
        <div className='tournaments-naviagation'>
          <div className="base-tabs">
            <a href="#tournament=all" className={cn("base-tab", {
              '-active': activeTab === 'all'
            })}>{gettext('Все')}</a>
            <a href="#tournament=past" className={cn("base-tab", {
              '-active': activeTab === 'past'
            })}>{gettext('Завершённые')}</a>
          </div>
          <DatePicker
            className='tournament-date-picker'
            value={date}
            onChange={(date) => {
              this.setState({date})
            }}
            renderInput={renderInputDateStepper}
          />
        </div>
        <div className='tournaments-table-body'>
          {Tournaments.get('status') === 'loading' ? (
            <div className='loader-ui'>
              <div/>
              <div/>
              <div/>
              <div/>
              <div/>
            </div>
          ) : !tournamentsFiltered.length && (
            <EmptyState prev={this.handlerShiftDay(-1)} next={this.handlerShiftDay(1)}/>
          )}
          {tournamentsFiltered.map(tournament => (
            <a href={tournament.absolute_url} key={tournament.id}
               className='tournament-row' onClick={this.handlerRowClick(tournament)}>
              <div className="tournament-row__logo">
                <a href={tournament.league.absolute_url} data-inside-link>
                  <img src={tournament.league.image} alt={tournament.league.name}/>
                </a>
              </div>
              <div className='tournament-row__body'>
                <div className="tournament-row__name">
                  {tournament.title}
                </div>
                <div className="tournament-row__desc">
                  <div className="tournament-row__desc-block">
                    <div className="tournament-row__desc-name">{gettext('Формат игры:')}</div>
                    <div className="tournament-row__desc-value">{tournament.type_game_display}</div>
                  </div>
                  {tournament.completed && tournament.winner ? (
                    <div className="tournament-row__desc-block">
                      <div className="tournament-row__desc-name">{gettext('Победитель:')}</div>
                      <div className="tournament-row__desc-value">
                        <a href={URLS.player_view.replace('0', tournament.winner.id)} data-inside-link>
                          {tournament.winner.short_name}
                        </a>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="tournament-row__extra">
                <div className='tournament-row__info'>
                  <div className={cn('tournament-row__info-status', `-${Tournaments.getStatus(tournament)}`)}>
                    {Tournaments.getStatusText(tournament)}
                  </div>
                  <div className="tournament-row__info-date">
                    {formattedDate.format(new Date(tournament.date))}
                  </div>
                </div>
              </div>
            </a>))}
        </div>
      </div>
    )
  }
}

const TableTournamentsWithStore = createStore(withStore(TableTournaments), {
  Tournaments,
}, {
  tournaments: [],
})

const root = ReactDOM.createRoot(document.getElementById('table-tournaments'));
root.render(
  <TableTournamentsWithStore/>
);